import { makeAutoObservable } from 'mobx'

class Paginator {
    count = 0
    total = 0
    perPage = 10
    currentPage = 1
    totalPages = 1

    constructor(count, total, perPage, currentPage, totalPages) {
        this.count = count
        this.total = total
        this.perPage = perPage
        this.currentPage = currentPage
        this.totalPages = totalPages

        makeAutoObservable(this)
    }

    setCurrentPage(currentPage) {
        this.currentPage = currentPage
    }

    static fromJson({ count, total, perPage, currentPage, totalPages }) {
        return new Paginator(count, total, perPage, currentPage, totalPages)
    }

    static empty() {
        return new Paginator(0, 0, 10, 1, 1)
    }
}

export default Paginator
